__turbopack_context__.v({
  "wrapper": "contentLayout-module-scss-module__V3UqaW__wrapper",
});
